<div class="w-full">
  <app-search-bar [showPrimaryBtn]="false" (onPrimaryBtnClick)="showDialog()"
    (formValueChange)="onFormValueChange($event)" [showFilterBtn]="true"
    (onFilterBtnClick)="showFilterModal()"></app-search-bar>
  <ng-container *ngIf="pagination?.data?.length; else noDataRepresent">
    <app-table [pagination]="pagination" [columns]="columns" [actions]="actionOptions"
      (pageChange)="onPageChange($event)" (actionSelected)="onActionSelected($event)">
    </app-table>
  </ng-container>
  <ng-template #noDataRepresent>
    <div class="no-data">
      <app-data-void [titulo]="'Nenhum Estudante encontrado'"
        [descricao]="'Atribua um auxilio de formação para o estudante'"></app-data-void>
    </div>
  </ng-template>
</div>
<p-toast></p-toast>
<p-confirmdialog></p-confirmdialog>

<p-dialog header="Filtros" [modal]="true" [(visible)]="showFilter" [style]="{ width: '40rem' }" appendTo="body">

  <form [formGroup]="form" class="p-fluid grid">
    <div *ngFor="let filter of filters" class="field col-6 d-flex flex-column">
      <label>{{ filter.placeholder }}</label>

      <!-- Se for dropdown -->
      <p-select *ngIf="filter.type === 'dropdown'" [filter]="true" [showClear]="true" appendTo="body"
        [options]="filter.options" [formControlName]="filter.controlName" [placeholder]="filter.placeholder"
        [optionLabel]="filter.optionLabel" [optionValue]="filter.optionValue">
      </p-select>

      <!-- Se for texto -->
      <input *ngIf="filter.type === 'text'" pInputText [formControlName]="filter.controlName"
        [placeholder]="filter.placeholder" class="w-full" />
    </div>
  </form>


  <div class="flex items-center justify-content-between">
    <p-button label="Cancelar" severity="secondary" (click)="showFilter = false" />
    <p-button label="Pesquisar" (click)="onFormValueChange(form.value)" />
  </div>
</p-dialog>